export default "__VITE_ASSET__51afc91f__"